import * as yup from 'yup';
import { useFormik } from 'formik';
import { translate } from 'i18n/jhipster-language';
import { optionalDescriptionField, optionalTextField } from './yup-helpers';
const initialValues = () => ({
    cardId: null,
    reason: 'CUSTOMER_REQUEST',
    sourceChannel: 'BRANCH',
    notes: '',
    performedBy: '',
    unfreezeReason: '',
    attachment: '',
});
/**
 * Shared Formik/Yup setup for freeze and unfreeze request creation (same fields + optional unfreeze copy).
 */
export const form = (props) => {
    const validationSchema = yup.object().shape({
        cardId: yup
            .number()
            .typeError(translate('entity.validation.number'))
            .required(translate('entity.validation.required'))
            .min(1, translate('entity.validation.min', { min: 1 })),
        reason: yup.string().required(translate('entity.validation.required')),
        sourceChannel: yup.string().required(translate('entity.validation.required')),
        notes: optionalDescriptionField(),
        performedBy: optionalTextField(),
        unfreezeReason: optionalDescriptionField(),
        attachment: optionalTextField(),
    });
    return useFormik({
        initialValues: initialValues(),
        enableReinitialize: true,
        validationSchema,
        validateOnChange: true,
        validateOnBlur: true,
        onSubmit: (data) => {
            if (data.cardId == null) {
                return;
            }
            const base = {
                cardId: data.cardId,
                reason: data.reason,
                sourceChannel: data.sourceChannel,
                notes: data.notes.trim() ? data.notes.trim() : undefined,
                performedBy: data.performedBy.trim() ? data.performedBy.trim() : undefined,
                attachment: data.attachment.trim() ? data.attachment.trim() : undefined,
            };
            if (props.kind === 'freeze') {
                const body = base;
                props.createEntity(body);
                return;
            }
            const body = {
                ...base,
                unfreezeReason: data.unfreezeReason.trim() ? data.unfreezeReason.trim() : undefined,
            };
            props.createEntity(body);
        },
    });
};
